import FuseLoadable from '@fuse/components/FuseLoadable/FuseLoadable'

export const AssegnazioneSkillConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/assegnazione_skill',
      component: FuseLoadable({
        loader: () => import('./AssegnazioneSkill')
      })
    }
  ]
}
